var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"code",staticStyle:{"height":"calc(100vh - 0px)","width":"calc(100% - 0px)","overflow":"hidden"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }